import { createStore } from 'vuex'
import { auth } from "./auth.module";
import { app } from "./app.module";

export default createStore({
  modules: {
    app,
    auth,
  }
})